import { NewMatchCardSchema } from '@/views/sports/components/NewMatchCard/styles/NewMatchCard.styles';

export const newMatchCardStyles: NewMatchCardSchema = {
  boxWrapper: {
    borderRadius: 'md',
    boxShadow:
      '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
    overflow: 'hidden',
  },
  bodyStack: {
    p: 2,
    borderTopRadius: 'md',
    m: '1px',
    mb: '0',
    bg: 'alpha.500',
    color: 'gray.700',
    fontWeight: 'bold',
  },
  titleHeading: {
    cursor: 'pointer',
    as: 'h5',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontFamily: 'Staatliches',
    fontSize: 'sm',
    fontWeight: 'normal',
    color: 'white',
  },
  footerFlex: {
    as: 'footer',
    bg: 'alpha.600',
    boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 0.10)',
    fontSize: '2xs',
    fontWeight: 'semibold',
    px: '2',
    py: '1',
    borderTop: '1px',
    borderColor: 'blackAlpha.300',
    m: '1px',
    mt: '0',
    borderBottomRadius: 'md',
    alignItems: 'center',
    gap: '1',
  },
  footerStack: {
    direction: 'row',
  },
  footerStackDivider: {
    height: '2.5',
    borderColor: 'white',
  },
  footerSportNameFlex: {
    align: 'center',
    gap: '1',
    maxW: '85%',
    w: 'fit-content',
    mr: '2',
  },
  footerSportNameIconSvg: {
    color: 'beta.500',
    fontSize: 'md',
  },
  footerCompetitionNameText: {
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 'initial',
    },
  },
  footerCountDown: {
    sx: {
      '&&&.state-prior': {
        textTransform: 'uppercase',
      },
    },
    sxWrapper: {
      mr: 'auto',
    },
  },
  footerDuotoneSgmLogo: {
    h: 'auto',
    primaryColor: 'alpha.500',
    secondaryColor: 'beta.600',
    w: '10',
  },
  footerMatchLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 'initial',
    fontWeight: 'normal',
  },
  footerMatchLinkIcon: {
    color: 'beta.500',
    fontSize: 'md',
  },
};
